/* @generated */
import * as React from "react";
import classnames from "classnames";
import { normalizeResponsiveValue, mapResponsiveValue } from "../config/atoms.css.esm.js";
import { splitStyle, directionVariants, xsGap, sGap, mGap, lGap, xlGap } from "./split.css.esm.js";
import { spacing } from "../config/spacing.esm.js";
import { getResponsiveStyling, ALIGN_X_TO_FLEX_ALIGN, walkByBreakpoint, ALIGN_Y_TO_FLEX_ALIGN } from "../config/responsive.esm.js";
import { resolveResponsivePropToClassName } from "../config/resolveResponsivePropToClassNames.esm.js";
import "../tokens.css.esm.js";
import { Box } from "../box/box.esm.js";
const GAP_VAR_MAPPING = {
  xsmall: xsGap,
  small: sGap,
  medium: mGap,
  large: lGap,
  xlarge: xlGap
};
const Split = ({
  children,
  alignX = "left",
  alignY = "top",
  wrap,
  gap,
  direction = "horizontal",
  className,
  display,
  style,
  ...rest
}) => {
  const [responsiveGapClasses, gapVarsStyle] = getResponsiveStyling({
    styleProps: gap,
    varMap: spacing,
    sizeToStylingMapping: GAP_VAR_MAPPING
  });
  const styl = { ...style, ...gapVarsStyle };
  const justifyContent = normalizeResponsiveValue(
    mapResponsiveValue(alignX, (value) => ALIGN_X_TO_FLEX_ALIGN[value])
  );
  const alignItems = walkByBreakpoint(
    normalizeResponsiveValue(mapResponsiveValue(alignY, (value) => ALIGN_Y_TO_FLEX_ALIGN[value])),
    "flex-start"
  );
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      as: "span",
      display: display ? display : "block",
      ...rest,
      className: classnames(splitStyle, className)
    },
    /* @__PURE__ */ React.createElement(
      Box,
      {
        as: "span",
        display: "flex",
        justifyContent,
        flexWrap: wrap,
        style: styl,
        className: classnames(
          responsiveGapClasses,
          resolveResponsivePropToClassName(
            direction,
            directionVariants.xsmall[alignItems.xsmall],
            directionVariants.small[alignItems.small],
            directionVariants.medium[alignItems.medium],
            directionVariants.large[alignItems.large],
            directionVariants.xlarge[alignItems.xlarge]
          )
        )
      },
      children
    )
  );
};
export {
  Split
};
